<template>
  <div>
    <h1>{{computedHeading}}</h1>
    <product-item-create
      :ams_template="ams_template"
      :reroute="reroute"
    ></product-item-create>
  </div>
</template>

<script>
import ProductItemCreate from './ProductItemCreate.vue'
import {humanize, singularize} from '@/utils'

export default {
  components: {
    ProductItemCreate
  },
  computed: {
     computedHeading() {
      if (this.ams_template) {
        return "Add " + singularize(humanize(this.ams_template['type']) + " to collection")
      }
      else {
        return "Add Asset"
      }
     }
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    }
  }
}
</script>